<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <h5>Lista Cavalli</h5>
              <div style="display: flex;">
                <button type="button" style="margin-left: 10px;" id="import-btn" class="btn btn-sm bg-gradient-success" @click="searchMicrochipModal=1">+ Segui Nuovo</button>
              </div>
              <!-- <button type="button" id="add-btn" class="btn btn-primary" @click="this.$router.push({ name: 'HorseAdd', params: {  } });">+ Nuovo</button> -->
            </div>
            <div class="card-body px-0 pt-0 pb-2" v-if="showtabs">
              <ul
                class="p-1 bg-transparent nav nav-pills nav-fill"
                role="tablist"
                style="max-width: 400px; margin: auto;"
              >
                <li class="nav-item">
                  <a
                    class="px-0 py-1 mb-0 nav-link active"
                    data-bs-toggle="tab"
                    href="javascript:;"
                    role="tab"
                    aria-selected="true"
                    :class="{ active: activeTab === 'owned' }"
                    @click="setActiveTab('owned')"
                  >
                    <span class="ms-1">Owned Horses</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="px-0 py-1 mb-0 nav-link"
                    data-bs-toggle="tab"
                    href="javascript:;"
                    role="tab"
                    aria-selected="false"
                    :class="{ active: activeTab === 'followed' }"
                    @click="setActiveTab('followed')"
                  >
                    <span class="ms-1">Followed Horses</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-3" id="table" :class="{ tloading: loading }">
                <custom-table ref="table$" :rows="data" @action="runAction"
                              :columns="[
                                  {
                                      title: 'Foto',
                                      type: 'horse-avatar',
                                      link: '/horses/:id/view',
                                      data: 'horse_images',
                                  },
                                  {
                                      title: 'Nome',
                                      link: '/horses/:id/view',
                                      type: 'text',
                                      data: 'name',
                                  },
                                  {
                                      title: 'Nickname',
                                      type: 'text',
                                      data: 'nickname',
                                  },
                                  {
                                      title: 'Microchip',
                                      type: 'badge',
                                      data: 'microchip',
                                      color: 'danger'
                                  },
                                  {
                                      title: 'Confirmed?',
                                      type: 'boolean',
                                      data: 'is_confirmed',
                                      on_label: 'Si',
                                      off_label: 'No'
                                  }
                              ]"
                              :actions="[
                                  {
                                      title: 'View',
                                      tooltip: 'view',
                                      key: 'view',
                                  }
                              ]"
                              :pagination="pagination"
                              @page-changed="handlePageChange"
                              @update-pagination="handlePaginationUpdate"
                              @search-changed="handleSearchChange"
                />
              </div>
            </div>
          </div>

            <!-- Confirmation Modal -->
          <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="confirmationModalLabel">Conferma Azione</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  Confermi operazione?
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary"  id="close" data-bs-dismiss="modal">Chiudi</button>
                  <button type="button" class="btn btn-primary" id="confirmButton" :class="{ loading: loading }" @click="deleteHorse">Conferma</button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <follow-horse v-model:show="searchMicrochipModal" @done="fetchData" />

</template>


<script>

import {horsesService} from "@/services/HorsesService";
import CustomTable from "@/components/CustomTable.vue";
import { useToast } from "vue-toastification";
import { Modal } from "bootstrap/dist/js/bootstrap.min";
import {useTableData} from "@/composables/useTableData";
import setNavPills from "@/assets/js/nav-pills.js";
import FollowHorse from "@/components/FollowHorse";

const toast = useToast();

export default {
  name: "VeteranarianHorses",
  data() {
    return {
      selected_horse: null,
      horsesData: [],
      activeTab: 'followed',
      showtabs: 0,
      searchMicrochipModal: 0,
    };
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', []);
  },
  setup(){
    return useTableData(
        horsesService.getCurrentUserHorses.bind(horsesService),
        15
    );
  },
  components: {
    CustomTable,
    FollowHorse,
  },
  mounted() {
    this.fetchData({type: this.activeTab});
    setNavPills();
  },
  methods: {
    async runAction({action, row}){
      if(action.key == 'edit'){
        this.$router.push({ name: 'Horse', params: { id: row.id } });
      }
      if(action.key == 'view'){
        this.$router.push({ name: 'Horse', params: { id: row.id, action: 'view' } });
      }
      if(action.key == 'delete'){
        const myModal = new Modal(document.getElementById('confirmationModal'));
        myModal.show();
        this.selected_horse = row.id;
      }
    },
    async deleteHorse(){
      this.loading = true;
      await horsesService.deleteHorseById(this.selected_horse);
      this.loading = false;
      toast(this.$t('Deleted'));
      document.getElementById('close').click();
      this.fetchData();
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.fetchData({type: tab});
    },
  }
};
</script>
